import store from '@/store/store'
import router from '@/plugins/router.js'

export const usePickTenant = (tenant, tenants) => {
  store.dispatch('user/pickTenant', tenant).then(() => {
    localStorage.setItem(
      'tenants',
      JSON.stringify({
        SelectedTenant: tenant,
        AvailableTenants: tenants
      })
    )
    if (store.getters['user/loggedIn']) {
      var route = store.getters['user/isDriverRole'] ? '/map/poi' : '/map/realtime'
      router.push(route)
    }
  })
}
export const useAuth = (username, password) => {
  store
    .dispatch('user/login', {
      userName: username,
      password: password
    })
    .then(() => {
      let tenants =
        localStorage.getItem('tenants') == null
          ? store.getters['user/tenants']
          : JSON.parse(localStorage.getItem('tenants'))
      if (tenants.length <= 1) {
        usePickTenant(tenants[0], tenants)
      }
    })
}
export const useLocalAuth = (username, password, savePassword) => {
  store
    .dispatch('user/localLoginAction', {
      userName: username,
      password: password,
      savePassword: savePassword
    })
    .then(() => {
      if (store.getters['user/loggedIn']) {
        var route = store.getters['user/isDriverRole'] ? '/map/poi' : '/map/realtime'
        router.push(route)
      }
    })
}
export const useLocalTenantAuth = (loginKey, tenantId, savePassword) => {
  store
    .dispatch('user/localTenantAuth',{
      loginKey: loginKey,
      tenantId: tenantId,
      savePassword: savePassword
    })
    .then(() => {
      if (store.getters['user/loggedIn']) {
        var route = store.getters['user/isDriverRole'] ? '/map/poi' : '/map/realtime'
        router.push(route)
      }
    })
}
export const onLoginKeyExpiration = () => {
  store.dispatch(
    'notification/add',
    {
      type: 'warning',
      message: 'Your login key has expired, redirecting back to login page.'
    },
    {
      root: true
    }
  )

  setTimeout(() => {
    router.go()
  }, 650);
}